<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              求人をお調べする為に、今のご状況も教えてください！
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--select"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_1"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="select--col1">
            <select
              v-model="nowStatus"
              title="nowStatus"
              @change="changeNowStatusAction"
              :class="{fontBlack: isNowStatusFontBlack}"
            >
              <option value="">就業状況</option>
              <option
                v-for="(option, key) in nowStatuses"
                :key="key"
                :value="option.id"
              >{{ option.text }}</option>
            </select>
            <small>※ご自身に一番近いと思うものを選んでいただければ大丈夫です！（わからない項目は担当のカウンセラーが修正します）</small>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.nowStatus"
          @click.once="clickFixNowStatus"
          @click="changeNowStatusData"
        >{{ btnContent.nowStatus }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_1"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ displayNowStatus($parent.formData.now_status) }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_2 || show.confirmMessage_1">
      <writing-animation v-if="show.writing_2"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.confirmMessage_1">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              正社員で働いた期間はありますか？あれば教えてください！
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--select"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_2"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="select--col1">
            <select
              v-model="fullTimeWorkerPeriod"
              title="career"
              @change="changeFullTimeWorkerPeriodAction"
              :class="{fontBlack: isFullTimeWorkerPeriodFontBlack}"
            >
              <option value="">正社員期間</option>
              <option
                v-for="(option, key) in fullTimeWorkerPeriods"
                :key="key"
                :value="option.value"
              >{{ option.label }}</option>
            </select>
            <small>※近いものを選んでください！複数社ある場合は期間を合計してください。</small>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.fullTimeWorkerPeriod"
          @click.once="clickFixFullTimeWorkerPeriod"
          @click="changeFullTimeWorkerPeriodData"
        >{{ btnContent.fullTimeWorkerPeriod }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_2"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ fixFullTimeWorkerPeriodLabel }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_3 || show.confirmMessage_2">
      <writing-animation v-if="show.writing_3"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.confirmMessage_2">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              ありがとうございます！最適な求人検索のために最終学歴も教えてください！
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--select"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_3"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="select--col1">
            <select
              v-model="career"
              title="career"
              @change="changeCareerAction"
              :class="{fontBlack: isCareerFontBlack}"
            >
              <option value="">最終学歴</option>
              <option
                v-for="(option, key) in careers"
                :key="key"
                :value="option.id"
              >{{ option.text }}</option>
            </select>
            <small>※ご自身に一番近いと思うものを選んでいただければ大丈夫です！</small>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.career"
          @click.once="clickFixCareer"
          @click="changeCareerData"
        >{{ btnContent.career }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_3"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ displayCareer($parent.formData.career) }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_4 || show.confirmMessage_3">
      <writing-animation v-if="show.writing_4"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.confirmMessage_3">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              ありがとうございます！<br />
              ここからはあなたが選考を受ける際に必要な情報をうかがいますね。
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GenderMixin from '../../mixins/GenderMixin'
import nowStatuses from '../../mixins/NowStatusMixin'
import FullTimeWorkerPeriods from '../../mixins/FullTimeWorkerPeriodMixin'
import Careers from '../../mixins/CareerMixin'
import functionsMixin from '../../mixins/functionsMixin'
import WritingAnimation from '../animations/WritingAnimation'

export default {
  name: 'FormNowStatusAndCareer',
  mixins: [GenderMixin, nowStatuses, FullTimeWorkerPeriods, Careers, functionsMixin],
  components: {
    WritingAnimation
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        beforeMessage: false,
        writing_2: false,
        question: false,
        answer_1: false,
        next_1: false,
        fix_1: false,
        confirmMessage_1: false,
        answer_2: false,
        next_2: false,
        fix_2: false,
        writing_3: false,
        confirmMessage_2: false,
        answer_3: false,
        next_3: false,
        fix_3: false,
        writing_4: false,
        confirmMessage_3: false
      },
      isDisabled: {
        nowStatus: true,
        fullTimeWorkerPeriod: true,
        career: true
      },
      isFix: {
        nowStatus: false,
        fullTimeWorkerPeriod: false,
        career: false
      },
      btnContent: {
        nowStatus: '次へ',
        fullTimeWorkerPeriod: '次へ',
        career: '次へ'
      },
      nowStatus: '',
      fullTimeWorkerPeriod: '',
      career: '',
      isNowStatusFontBlack: false,
      isFullTimeWorkerPeriodFontBlack: false,
      isCareerFontBlack: false
    }
  },
  computed: {
    fixFullTimeWorkerPeriodLabel: function () {
      return this.$parent.formData.full_time_worker_period !== null && this.$parent.formData.full_time_worker_period !== undefined
        ? this.fullTimeWorkerPeriods
          .find(e => e.value === this.$parent.formData.full_time_worker_period)
          .label
        : ''
    }
  },
  mounted: function () {
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.question = true
      this.autoScroll()
      setTimeout(function () {
        this.show.answer_1 = true
        this.autoScroll()
      }.bind(this), 500)
    }.bind(this), 1000)
  },
  watch: {
    nowStatus: function (val) {
      // this.show.next_1 = val !== ''
      // if (this.show.next_1) {
      //   this.autoScroll()
      // }
    },
    career: function (val) {
      // this.show.next_2 = val !== ''
      // if (this.show.next_2) {
      //   this.autoScroll()
      // }
    }
  },
  methods: {
    changeNowStatusAction: function () {
      this.isNowStatusFontBlack = this.nowStatus !== ''
      if (this.nowStatus) {
        this.isDisabled.nowStatus = false
        if (this.isFix.nowStatus) {
          this.btnContent.nowStatus = '更新'
        } else {
          this.btnContent.nowStatus = '次へ'
        }
      } else {
        this.isDisabled.nowStatus = true
      }
    },
    changeFullTimeWorkerPeriodAction: function () {
      this.isFullTimeWorkerPeriodFontBlack = this.fullTimeWorkerPeriod !== ''
      if (this.fullTimeWorkerPeriod || this.fullTimeWorkerPeriod === 0) {
        this.isDisabled.fullTimeWorkerPeriod = false
        if (this.isFix.fullTimeWorkerPeriod) {
          this.btnContent.fullTimeWorkerPeriod = '更新'
        } else {
          this.btnContent.fullTimeWorkerPeriod = '次へ'
        }
      } else {
        this.isDisabled.fullTimeWorkerPeriod = true
      }
    },
    changeCareerAction: function () {
      this.isCareerFontBlack = this.career !== ''
      if (this.career) {
        this.isDisabled.career = false
        if (this.isFix.career) {
          this.btnContent.career = '更新'
        } else {
          this.btnContent.career = '次へ'
        }
      } else {
        this.isDisabled.career = true
      }
    },
    displayNowStatus: function (nowStatus) {
      if (nowStatus === '') {
        return ''
      }
      for (let key in this.nowStatuses) {
        if (this.nowStatuses.hasOwnProperty(key)) {
          if (this.nowStatuses[key].id === nowStatus) {
            return this.nowStatuses[key].text
          }
        }
      }
    },
    displayCareer: function (career) {
      if (career === '') {
        return ''
      }
      for (let key in this.careers) {
        if (this.careers.hasOwnProperty(key)) {
          if (this.careers[key].id === career) {
            return this.careers[key].text
          }
        }
      }
    },
    clickFixNowStatus: function () {
      this.show.answer_1 = false
      this.isFix.nowStatus = true
      this.isDisabled.nowStatus = true
      this.$emit('form-fix-now-status', this.nowStatus)
      this.show.fix_1 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_2 = true
        this.autoScroll()
        setTimeout(function () {
          this.show.writing_2 = false
          this.show.confirmMessage_1 = true
          this.autoScroll()
          setTimeout(function () {
            this.show.answer_2 = true
            this.autoScroll()
          }.bind(this), 500)
        }.bind(this), 500)
      }.bind(this), 500)
    },
    clickFixFullTimeWorkerPeriod: function () {
      this.show.answer_2 = false
      this.isFix.fullTimeWorkerPeriod = true
      this.isDisabled.fullTimeWorkerPeriod = true
      this.$emit('form-fix-full-time-worker-period', this.fullTimeWorkerPeriod)
      this.show.fix_2 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_3 = true
        this.autoScroll()
        setTimeout(function () {
          this.show.writing_3 = false
          this.show.confirmMessage_2 = true
          this.autoScroll()
          setTimeout(function () {
            this.show.answer_3 = true
            this.autoScroll()
          }.bind(this), 500)
        }.bind(this), 500)
      }.bind(this), 500)
    },
    clickFixCareer: function () {
      this.show.answer_3 = false
      this.isFix.career = true
      this.isDisabled.career = true
      this.$emit('form-fix-career', this.career)
      this.show.fix_3 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_4 = true
        setTimeout(function () {
          this.show.writing_4 = false
          this.show.confirmMessage_3 = true
          this.autoScroll()
          this.$emit('form-next')
        }.bind(this), 1000)
      }.bind(this), 500)
    },
    changeNowStatusData: function () {
      if (this.isFix.nowStatus) {
        this.$emit('form-change-now-status', this.nowStatus)
        this.isDisabled.nowStatus = true
      }
    },
    changeFullTimeWorkerPeriodData: function () {
      if (this.isFix.fullTimeWorkerPeriod) {
        this.$emit('form-change-full-time-worker-period', this.fullTimeWorkerPeriod)
        this.isDisabled.fullTimeWorkerPeriod = true
      }
    },
    changeCareerData: function () {
      if (this.isFix.career) {
        this.$emit('form-change-career', this.career)
        this.isDisabled.career = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade {
    &-enter-active, &-leave-active {
      will-change: opacity;
      transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
  }
  .fontBlack {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/FormNowStatusAndCareer.vue